<template>
    <div class="mobile-page clearfix">
        <div class="advert"
             :style="{marginLeft:configData.lrConfig.val + 'px',marginRight:configData.lrConfig.val +'px',marginTop: configData.mbConfig.val+'px',background: configData.bgColor.color[0].item}">
            <div class="advertItem01 acea-row" v-if="configData.swiperConfig.list.length === 1"
                 v-for="(item,index) in configData.swiperConfig.list" :key="index">
                <img :src="item.img" v-if="item.img">
                <div class="empty-box" v-else>
                    <span class="iconfont icontupian"></span>
                </div>
            </div>
            <div class="advertItem02 acea-row" v-if="configData.swiperConfig.list.length === 2">
                <div class="item" v-for="(item,index) in configData.swiperConfig.list" :key="index">
                    <img :src="item.img" v-if="item.img">
                    <div class="empty-box" v-else>
                        <span class="iconfont icontupian"></span>
                    </div>
                </div>
            </div>
            <div class="advertItem02 advertItem03 acea-row" v-if="configData.swiperConfig.list.length === 3">
                <div class="item" v-for="(item,index) in configData.swiperConfig.list" :key="index">
                    <img :src="item.img" v-if="item.img">
                    <div class="empty-box" v-else>
                        <span class="iconfont icontupian"></span>
                    </div>
                </div>
            </div>
            <div class="advertItem06 acea-row" v-if="configData.swiperConfig.list.length === 4">
                <div class="item" v-for="(item,index) in configData.swiperConfig.list" :key="index">
                    <img :src="item.img" v-if="item.img">
                    <div class="empty-box" v-else>
                        <span class="iconfont icontupian"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "picturecube",
        cname: '图片魔方',
        sort: 200,
        type: 0, // 0 基础组件 1 营销组件 2工具组件
        icon: 'iconcuxiaoliebiao1',
        props: {
            configData: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                defaultConfig: {
                    name: "picturecube",
                    cname: '图片魔方',
                    tabs: [
                        {
                            title: '内容设置'
                        },
                        {
                            title: '样式设置'
                        }
                    ],
                    styles: {
                        // 图片列表
                        swiperConfig: {
                            tab: 0,
                            name: 'images',
                            title: "布局",
                            maxList: 4,
                            showTitle: false,
                            list: [
                                {
                                    img: "",
                                    info: [
                                        {
                                            title: "链接",
                                            value: "",
                                            tips: "请输入链接",
                                            max: 100,
                                        },
                                    ],
                                },
                            ],
                        },
                        isShow: {
                            tab: 1,
                            name: 'editorswitch',
                            title: '是否显示背景色',
                            val: true
                        },
                        // 背景颜色
                        bgColor: {
                            tab: 1,
                            name: 'colors',
                            title: "背景颜色(渐变)",
                            default: [
                                {
                                    item: "#6495ED",
                                },
                                {
                                    item: "#6495ED",
                                },
                            ],
                            color: [
                                {
                                    item: "#6495ED",
                                },
                                {
                                    item: "#6495ED",
                                },
                            ],
                        },
                        // 左右间距
                        lrConfig: {
                            tab: 1,
                            name: 'slider',
                            title: "左右边距",
                            val: 10,
                            min: 0,
                        },
                        // 页面间距
                        mbConfig: {
                            tab: 1,
                            name: 'slider',
                            title: "页面间距",
                            val: 0,
                            min: 0,
                        },
                    }
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .mobile-page {
        position: relative;
        width: auto;
        position: relative;
        overflow: hidden;
    }

    .mobile-page{
        .advert{
            .advertItem01{
                width: 100%;
                height: 100%;
                .empty-box{
                    width: 100%;
                    height: 379px;
                    border-radius: 0;
                    .icontupian{
                        font-size: 50px;
                        color: #999;
                    }
                }
                img{
                    width: 100%;
                    height: 100%
                }
            }
            .advertItem02{
                width: 100%;
                .item {
                    width: 50%;
                    height: auto;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                    .empty-box{
                        width: 100%;
                        height: 189.5px;
                        border-radius: 0;
                    }
                }
            }
            .advertItem03{
                .item{
                    width: 33.3333%;
                    .empty-box{
                        width: 100%;
                        height: 126.4px;
                        border-radius: 0;
                    }
                }
            }
            .advertItem04{
                .item{
                    width: 50%;
                    height: 189.5px;
                    .empty-box{
                        width: 100%;
                        height: 100%;
                        border-radius: 0;
                    }
                    img{
                        width: 100%;
                        height: 100%;
                    }
                    .pic{
                        width: 100%;
                        height: 94.75px;
                    }
                }
            }
            .advertItem05{
                .item{
                    width: 25%;
                    .empty-box{
                        width: 100%;
                        height: 94.75px;
                        border-radius: 0;
                    }
                }
            }
            .advertItem06{
                .item{
                    width: 50%;
                    height: 95px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                    .empty-box{
                        width: 100%;
                        height: 100%;
                        border-radius: 0;
                    }
                }
            }
        }
    }
</style>
